import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import { Row, Col, Alert, Card, CardBody, Container, FormFeedback, Input, Label, Form } from "reactstrap";
import logolight from "../../assets/images/logotop.png";
import logodark from "../../assets/images/logotop.png";

//redux
import { useSelector, useDispatch } from "react-redux";

import { Link } from "react-router-dom";
import withRouter from "../../components/Common/withRouter";

// Formik Validation
import * as Yup from "yup";
import { useFormik } from "formik";

// action
import { apiError, userForgetPassword } from "../../store/actions";

import { isGmail } from "../../helpers/authErrors";
import { GmailNotice } from "./AuthComponents";

const ForgetPasswordPage = props => {
  const dispatch = useDispatch();
  document.title = "Ticket Control Monitor | Recuperación de Contraseña";

  // Con un Gmail escrito se ofrece Google en lugar de recuperar una clave.
  const [usePassword, setUsePassword] = useState(false);
  // El resultado queda guardado en Redux: sin esto, al volver a esta pantalla
  // se vería el aviso de "email enviado" sin el formulario para pedir otro.
  const [submitted, setSubmitted] = useState(false);

  const validation = useFormik({
    enableReinitialize: true,
    initialValues: {
      email: '',
    },
    validationSchema: Yup.object({
      email: Yup.string()
        .trim()
        .email("Revisa el email: debe tener el formato nombre@ejemplo.com")
        .required("Escribe tu email")
    }),
    onSubmit: (values) => {
      setSubmitted(true);
      dispatch(userForgetPassword({ ...values, email: values.email.trim() }, props.router.navigate));
    }
  });

  const { forgetError, forgetSuccessMsg, googleError } = useSelector(state => ({
    forgetError: state.forgetPassword.forgetError,
    forgetSuccessMsg: state.forgetPassword.forgetSuccessMsg,
    // El botón de Google informa sus errores en el estado de login.
    googleError: state.login.error,
  }));

  const sent = submitted && forgetSuccessMsg;
  const error = (submitted && forgetError) || googleError;
  const gmailNotice = isGmail(validation.values.email) && !usePassword;

  useEffect(() => {
    document.body.className = "bg-pattern";
    return function cleanup() {
      document.body.className = "";
    };
  });

  useEffect(() => {
    dispatch(apiError(""));
  }, [dispatch]);

  return (
    <React.Fragment>
      <div className="bg-overlay"></div>
      <div className="account-pages my-5 pt-5">
        <Container>
          <Row className="justify-content-center">
            <Col lg={6} md={8} xl={4}>
              <Card className="shadow" style={{ borderRadius: 12, border: "none" }}>
                <CardBody className="p-4">
                  <div className="text-center mb-4">
                    <Link to="/">
                      <img
                        src={logodark}
                        alt=""
                        height="50"
                        className="auth-logo logo-dark mx-auto"
                      />
                      <img
                        src={logolight}
                        alt=""
                        height="24"
                        className="auth-logo logo-light mx-auto"
                      />
                    </Link>
                    <h4 className="mt-3 mb-1" style={{ fontWeight: 700, color: "#333" }}>
                      Recuperar clave
                    </h4>
                    <p className="text-muted" style={{ fontSize: 14 }}>
                      Escribe tu email y te enviamos un enlace para crear una clave nueva
                    </p>
                  </div>

                  {error && !sent ? (
                    <Alert color="danger" className="d-flex align-items-center" style={{ borderRadius: 8 }}>
                      <span className="material-symbols-rounded me-2" style={{ fontSize: 20 }}>error</span>
                      <div>
                        {typeof error === "string"
                          ? error
                          : "No pudimos enviar el email. Vuelve a intentarlo en unos minutos."}
                      </div>
                    </Alert>
                  ) : null}

                  {sent ? (
                    <div>
                      <Alert color="success" className="d-flex align-items-center" style={{ borderRadius: 8 }}>
                        <span className="material-symbols-rounded me-2" style={{ fontSize: 20 }}>check_circle</span>
                        <div>{forgetSuccessMsg}</div>
                      </Alert>
                      <Link to="/login" className="d-grid mt-4">
                        <button
                          className="btn btn-primary"
                          style={{ borderRadius: 8, padding: "10px", fontWeight: 600, fontSize: 15 }}
                        >
                          <span className="material-symbols-rounded me-1" style={{ fontSize: 18, verticalAlign: "middle" }}>login</span>
                          Ingresar
                        </button>
                      </Link>
                      <div className="text-center mt-3">
                        <button
                          type="button"
                          className="btn btn-link text-muted p-0"
                          style={{ fontSize: 13 }}
                          onClick={() => setSubmitted(false)}
                        >
                          ¿No te llegó? Enviar de nuevo
                        </button>
                      </div>
                    </div>
                  ) : null}

                  {!sent && <Form
                    className="form-horizontal"
                    onSubmit={(e) => {
                      e.preventDefault();
                      if (!gmailNotice) validation.handleSubmit();
                      return false;
                    }}
                  >
                    <div className="mb-3">
                      <Label className="form-label" style={{ fontWeight: 600, fontSize: 13 }}>
                        <span className="material-symbols-rounded me-1" style={{ fontSize: 16, verticalAlign: "middle" }}>mail</span>
                        Email
                      </Label>
                      <Input
                        name="email"
                        className="form-control"
                        placeholder="tu@email.com"
                        type="email"
                        style={{ borderRadius: 8, padding: "10px 14px" }}
                        onChange={validation.handleChange}
                        onBlur={validation.handleBlur}
                        value={validation.values.email || ""}
                        invalid={
                          validation.touched.email && validation.errors.email ? true : false
                        }
                      />
                      {validation.touched.email && validation.errors.email ? (
                        <FormFeedback type="invalid"><div>{validation.errors.email}</div></FormFeedback>
                      ) : null}
                    </div>

                    {gmailNotice ? (
                      <GmailNotice
                        title="Con Gmail no necesitas clave"
                        skipLabel="Quiero recuperar mi clave de Monitor"
                        onSkip={() => setUsePassword(true)}
                      >
                        Toca el botón y elige tu cuenta de Gmail.
                      </GmailNotice>
                    ) : (
                      <div className="d-grid mt-4">
                        <button
                          className="btn btn-primary"
                          type="submit"
                          style={{ borderRadius: 8, padding: "10px", fontWeight: 600, fontSize: 15 }}
                        >
                          <span className="material-symbols-rounded me-1" style={{ fontSize: 18, verticalAlign: "middle" }}>lock_reset</span>
                          Enviarme el enlace
                        </button>
                      </div>
                    )}
                  </Form>}
                </CardBody>
              </Card>

              <div className="mt-4 text-center">
                <p className="text-white-50" style={{ fontSize: 14 }}>
                  ¿Ya recuerdas tu clave?{" "}
                  <Link to="/login" className="fw-medium text-primary">Ingresa</Link>
                </p>
                <p className="text-white-50" style={{ fontSize: 14 }}>
                  ¿Primera vez sin Gmail?{" "}
                  <Link to="/register" className="fw-medium text-primary">Crea tu cuenta</Link>
                </p>
                <p className="text-white-50" style={{ fontSize: 12 }}>
                  © {new Date().getFullYear()} TicketControl Monitor - TicketControl Dev
                </p>
              </div>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

ForgetPasswordPage.propTypes = {
  history: PropTypes.object,
};

export default withRouter(ForgetPasswordPage);
